import * as React from "react";
import { Grid, Link, Modal } from "@mui/material";
import CoreTeamList from "./CoreTeamList";
import ProviderShow from "./ProviderShow";
import AddProviderModal from "./AddProviderModal";
import SwitchProviderModal from "./SwitchProviderModal";

interface Props {
  csrfToken: string;
  menu_track_src: string;
  user_id: number;
  sort_plain_src: string;
  sort_ascending_src: string;
  sort_descending_src: string;
  chat_icon_with_orange_line: string;
  the_wall_icon_grey: string;
  pencil_grey: string;
  button_src: string;
  fetchUserPrivileges: () => void;
}

const CoreTeamIndex: React.FC<Props> = (props: any) => {
  const [selectedProvider, setSelectedProvider] = React.useState<any>(null);
  const [unsaveChanges, setUnsavedChanges] = React.useState<boolean>(false);
  const [unsavedModalOpen, setUnsavedModalOpen] =
    React.useState<boolean>(false);

  // this state us used for pateint selection check when patient is changes on edit page
  const [tempSelectedProvider, setTempSelectedProvider] =
    React.useState<any>(null);
  const [privilegesModalOpen, setPrivilegesModalOpen] =
    React.useState<boolean>(false);
  const [showAddProviderModal, setShowAddProviderModal] =
    React.useState<boolean>(false);
  const [isEditing, setIsEditing] = React.useState<boolean>(false);

  const confirmOnSaveModal = () => {
    setSelectedProvider(tempSelectedProvider);
    setUnsavedModalOpen(false);
    setUnsavedChanges(false);
  };

  const [reloadKey, setReloadKey] = React.useState<number>(0);

  const openAddProviderModal = () => setShowAddProviderModal(true);

  const handleEditingOn = (event) => {
    event.preventDefault();
    setIsEditing(true);
    setShowAddProviderModal(true);
  };

  return (
    <div className="coreTeam">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="container2"
      >
        <CoreTeamList
          csrfToken={props.csrfToken}
          menu_track_src={props.menu_track_src}
          sort_plain_src={props.sort_plain_src}
          sort_ascending_src={props.sort_ascending_src}
          sort_descending_src={props.sort_descending_src}
          selectedProvider={selectedProvider}
          setSelectedProvider={setSelectedProvider}
          setTempSelectedProvider={setTempSelectedProvider}
          unsaveChanges={unsaveChanges}
          setUnsavedModalOpen={setUnsavedModalOpen}
          openAddProviderModal={openAddProviderModal}
          reloadKey={reloadKey}
        />

        {selectedProvider && (
          <ProviderShow
            selectedProvider={selectedProvider}
            chat_icon_with_orange_line={props.chat_icon_with_orange_line}
            the_wall_icon_grey={props.the_wall_icon_grey}
            pencil_grey={props.pencil_grey}
            menu_track_src={props.menu_track_src}
            setPrivilegesModalOpen={setPrivilegesModalOpen}
            privilegesModalOpen={privilegesModalOpen}
            user_id={props.user_id}
            handleEditingOn={handleEditingOn}
            fetchUserPrivileges={props.fetchUserPrivileges}
          />
        )}

        {unsavedModalOpen && (
          <SwitchProviderModal
            open={unsavedModalOpen}
            closeModal={() => setUnsavedModalOpen(false)}
            handleConfirm={confirmOnSaveModal}
          />
        )}
      </Grid>

      {showAddProviderModal && (
        <AddProviderModal
          selectedProvider={isEditing ? selectedProvider : null}
          showAddProviderModal={showAddProviderModal}
          setShowAddProviderModal={setShowAddProviderModal}
          csrfToken={props.csrfToken}
          unsaveChanges={unsaveChanges}
          setUnsavedChanges={setUnsavedChanges}
          setUnsavedModalOpen={setUnsavedModalOpen}
          setIsEditing={setIsEditing}
          setSelectedProvider={setSelectedProvider}
          updateProviderReloadKey={() => setReloadKey((k) => k + 1)}
        />
      )}
    </div>
  );
};

export default CoreTeamIndex;
